<template>
  <div class="container">
    <div class="row mt-2">
      <div class="col">
        <h1>
          {{
            $t("discover.by_country.content_from", {
              country: countryName,
            })
          }}
        </h1>
        <p v-if="!loading" class="text-secondary">
          <span>{{
            $t("discover.by_country.result_count", { count: movieCount })
          }}</span>
        </p>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-3 p-1" v-for="(asset, i) in shownAssets" v-bind:key="i">
        <vertical-card :asset="asset" />
      </div>
    </div>

    <!--    <div class="row justify-content-center my-5" v-if="!show_all && !loading">-->
    <!--      <div class="d-flex">-->
    <!--        <button class="btn browse-all btn-outline-light" @click="showAll">-->
    <!--          {{ $t("load_more") }}-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import VerticalCard from "@/components/landing/carousel/VerticalCard.vue";
import { OrizonApiClient } from "@/services/OrizonApiClient";
import { i18n } from "@/functional/languages";
import MetaService from "@/services/MetaService";
const apiClient = new OrizonApiClient();
export default {
  name: "CountryMovies",
  metaInfo: () => {
    return {
      title: i18n.global.t("discover.meta.title"),
      htmlAttrs: { lang: i18n.global.locale },
      meta: [
        MetaService.robotIndex(),
        MetaService.description(i18n.global.t("discover.meta.description")),
      ],
    };
  },
  components: { VerticalCard },
  props: {
    country: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  data: () => ({
    assets: [],
    movieCount: 0,
    show_all: false,
    loading: false,
  }),
  async beforeMount() {
    await this.getCountryAssets();
  },
  mounted() {
    MetaService.clearDefaultCanonical();
    console.log("mounted");
  },
  updated() {
    MetaService.updateTitle(
      i18n.global.t("discover.country.meta.title", {
        country: this.countryName,
      })
    );
    MetaService.updateDescription(
      i18n.global.t("discover.country.meta.description", {
        country: this.countryName,
      })
    );
    MetaService.clearDefaultCanonical();
    MetaService.updateCanonical(this.$route["path"], {
      en: `/en/discover/${this.countrySlugEn}`,
      es: `/es/descubre/${this.countrySlugEs}`,
    });
    i18n.global.mergeLocaleMessage("en", {
      browse_by_country: `/en/discover/${this.countrySlugEn}`,
    });
    i18n.global.mergeLocaleMessage("es", {
      browse_by_country: `/es/descubre/${this.countrySlugEs}`,
    });
    console.log("updated");
  },
  beforeRouteUpdate(to, from, next) {
    this.getCountryAssets();
    next();
  },
  methods: {
    getCountryAssets() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      apiClient.getCountryAssets(this.country).then((response) => {
        this.loading = false;
        this.assets = response.data;
        this.movieCount = this.assets.length;
      });
    },
    showAll() {
      this.show_all = true;
    },
  },
  computed: {
    shownAssets() {
      if (!this.assets) {
        return [];
      }
      return this.assets; //this.show_all ? this.assets : this.assets.splice(0, 20);
    },
    countryName() {
      return this.shownAssets[0] === undefined
        ? ""
        : this.shownAssets[0].country;
    },
    countrySlugEn() {
      return this.shownAssets[0] === undefined
        ? ""
        : this.shownAssets[0].locale["en"]["country_slug"];
    },
    countrySlugEs() {
      return this.shownAssets[0] === undefined
        ? ""
        : this.shownAssets[0].locale["es"]["country_slug"];
    },
    // movieCount() {
    //   return this.assets ? this.assets.length : 0;
    // },
  },
};
</script>

<style scoped></style>
